<template>
    <header class="d-flex align-items-center justify-content-between p-3 mb-0 fw-bold add-member-header">
        {{ isGroupConversation ? "Add Member" : "Start a group chat" }}
        <img
            class="cursor-pointer"
            src="../../../assets/images/Notification/call-noti-close-icon.svg"
            @click="cancel()"
        />
    </header>
    <TagsInput
        class="w-100 p-3"
        :getData="getUsersList"
        :tags="users"
        v-on:updateTags="updateTags"
        placeholder="Enter name"
        :is-focus="true"
        :is-for-messaging="true"
        :show-pill="false"
        classes="w-100 grey-input"
        focusOnInput="true"
    />
    <div class="axxess-logo-bg"></div>
    <div class="chat-history-box m-3" v-if="isGroupConversation && !isDraftConversation">
        <div class="form-group form-check custom-checkbox mb-0">
            <input type="checkbox" class="form-check-input" v-model="includeChatHistory" id="chat-history" />
            <label class="form-check-label" for="chat-history"> Share entire chat history</label>
        </div>
    </div>

    <footer class="d-flex justify-content-center pb-3">
        <button
            type="button"
            class="btn btn-light border border-secondary me-2 w-30"
            :disabled="isLoading"
            @click="cancel()"
        >
            Cancel
        </button>
        <button type="button" class="btn btn-primary border border-primary w-30" :disabled="isLoading" @click="add()">
            {{ isGroupConversation ? "Add" : "Create" }}
        </button>
    </footer>
</template>

<script lang="ts" src="./AddMemberToChat.ts"></script>
<style src="./AddMemberToChat.scss"></style>
